import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20abstract%20composition%20with%20warm%20coral%20and%20amber%20gradients%20blending%20into%20deep%20charcoal%20tones%20modern%20minimalist%20geometric%20shapes%20floating%20with%20soft%20diffused%20lighting%20creating%20depth%20and%20mystery%20editorial%20grade%20color%20palette%20with%20rich%20contrast%20clean%20composition%20suitable%20for%20a%20media%20entertainment%20platform%20hero%20section%20no%20text%20no%20people%20just%20atmospheric%20abstract%20visuals&width=1600&height=800&seq=hero-bg-main-01&orientation=landscape"
          alt="51在线吃瓜"
          title="51在线吃瓜入口 - 最新吃瓜资讯"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10">
          <div className="lg:w-2/5 text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-500/90 text-background-50 rounded-full text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>今日最热 · 实时更新</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-5">
              最新<span className="italic text-primary-400">吃瓜</span>
              <br />
              一手爆料尽在掌握
            </h1>
            <p className="text-background-200 text-base md:text-lg leading-relaxed mb-8 max-w-md">
              51在线吃瓜入口，聚合全网最新明星八卦、网红爆料、社会热点。吃瓜视频在线观看，51在线吃瓜app下载，让你不错过任何一个瓜。
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="#trending"
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#download"
                className="px-6 py-3 border-2 border-background-300 text-background-50 rounded-full text-sm font-medium hover:border-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                下载APP
              </a>
            </div>
          </div>

          <div className="lg:w-3/5">
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photography%20style%20image%20of%20a%20smartphone%20screen%20displaying%20entertainment%20news%20feed%20with%20warm%20lighting%20the%20phone%20is%20placed%20on%20a%20dark%20surface%20with%20soft%20ambient%20glow%20modern%20minimalist%20composition%20with%20bokeh%20background%20rich%20coral%20and%20amber%20accents%20cinematic%20mood%20no%20text%20visible%20just%20abstract%20colorful%20feed%20layout&width=900&height=550&seq=hero-featured-main&orientation=landscape"
                alt="51在线吃瓜app"
                title="51在线吃瓜入口 - 吃瓜视频在线观看"
                className="w-full h-full object-cover object-top rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}